import {useContext, useEffect, useState} from 'react';
import { Outlet } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { Grid, Badge } from '@mui/material';
import Container from "@mui/material/Container";
import { useNavigate } from 'react-router-dom';
import { getCustomersAds } from 'src/service/customerApi';
import { getConversation } from 'src/service/conversationApi';
import AuthContext from 'src/contexts/AuthContext';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const ButtonStyle = styled('button')(({ theme }) => ({
  textAlign: 'center',
  padding: '50px',
  backgroundColor: '#e7f2f3',
  borderRadius: '20px',
  border: 'none',
  textTransform: 'uppercase',
  minWidth: '100%',
  '&:hover': {
    backgroundColor: "#009faa",
    color: "white"
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { customerId } = useContext(AuthContext)

  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle>
        <Container>
          <Outlet />
        </Container>
      </MainStyle>
    </RootStyle>
  );
}
